import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { ColorRing } from "react-loader-spinner"; // Optional spinner lib

const MediaCarousel = ({ urls }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % urls.length);
    setIframeLoaded(false);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + urls.length) % urls.length);
    setIframeLoaded(false);
  };

  const currentUrl = urls[currentIndex];
  const baseClass =
    "w-[65%] max-h-[100%] min-h-[15.625rem] rounded-lg object-contain";
  const baseClass3 =
    "w-[63%] max-h-[100%] min-h-[14.625rem] rounded-lg object-contain";  
  const baseClass2 =
    "w-[95%] max-h-[100%] min-h-[26.875rem] rounded-lg object-contain";  

  const renderMedia = (url) => {

    if (!url || (Array.isArray(url) && !url.length) || Number.isNaN(url)) {
    return (
      <p className="text-sm min-h-[19.825rem] flex justify-center items-center text-gray-500">
        No media available
      </p>
    );
  }
    if (url.includes("jpg") || url.includes("png")) {
      return <img src={url} className={baseClass} loading="lazy" />;
    } else if (url.includes(".mp4")) {
      return <video src={url} controls className={baseClass3} loading="lazy" />;
    } else if (url.includes(".html")) {
      return (
        <div className="relative flex justify-center items-center w-full">
          {!iframeLoaded && (
            <div className="absolute z-10 flex justify-center items-center">
              <ColorRing height={80} width={80} visible={true} 
                ariaLabel="blocks-loading"
                wrapperStyle={{}}
                wrapperClass="blocks-wrapper"
                colors={["#00319f", "#2e56b1", "#5c7bc2", "#8aa1d3", "#b2c1e2"]}

              />
            </div>
          )}
          <iframe
            src={url}
            className={`${baseClass2} ${!iframeLoaded ? "opacity-0" : "opacity-100"} transition-opacity duration-300`}
            loading="lazy"
            onLoad={() => setIframeLoaded(true)}
          />
        </div>
      );
    } else {
      return <p className="text-sm min-h-[19.825rem] flex justify-center items-center text-gray-500">Unsupported content</p>;
    }
  };

  return (
    <div className="relative w-full h-max flex justify-center items-center">
      {/* Arrows */}
      {urls.length > 1 && (
        <button
          onClick={handlePrev}
          className="absolute left-4 z-10 bg-white bg-opacity-70 p-2 rounded-full hover:bg-opacity-100 shadow"
        >
          <ChevronLeft className="w-6 h-6" />
        </button>
      )}

      {urls.length > 0 && (
        <div className="w-full flex flex-col justify-center items-center">
          <div className="w-full flex justify-center items-start pt-4">
            {currentUrl && renderMedia(currentUrl)}
          </div>
          <div className="mt-2 text-sm text-gray-600">
            {currentIndex + 1} / {urls.length}
          </div>
        </div>
      )}

       {urls.length > 1 && (
            <button
            onClick={handleNext}
            className="absolute right-4 z-10 bg-white bg-opacity-70 p-2 rounded-full hover:bg-opacity-100 shadow"
            >
            <ChevronRight className="w-6 h-6" />
            </button>
        )}
        {urls.length === 0 && (
          <div className="w-full flex justify-center h-full">
            <img
              src={"assets/img/no-image.png"}
              loading="lazy"
              className="w-[200px] px-2 min-h-[300px] max-w-[700px] lg:max-w-[600px] mx-auto rounded-lg object-contain relative  "
            />
          </div>
        )}
    </div>
  );
};
export default MediaCarousel;